import { createRouter, createWebHistory, START_LOCATION } from 'vue-router'

import store from '@/store'
import auth from '@/services/servicioAutenticacion'
import { esSubdominioLogin, construirUrlEmpresa, construirUrlLogout, obtenerRucDesdeSubdominio } from '@/utils/subdominio'

// ── Infraestructura ────────────────────────────────────────────────────────
import ClientLayout from '@/layouts/ClientLayout.vue'
import ModuleRestricted from '@/views/system/ModuleRestricted.vue'
import GestionPago from '@/views/system/GestionPago.vue'

// ── Autenticación ──────────────────────────────────────────────────────────
import InicioSesion from '@/views/auth/InicioSesion.vue'
import RecuperarClave from '@/views/auth/RecuperarClave.vue'
import ClientCambioClaveToken from '@/views/auth/ClientCambioClaveToken.vue'

// ── 1. Dashboard ───────────────────────────────────────────────────────────
import ClientDashboard from '@/views/dashboard/ClientDashboard.vue'

// ── 2. Facturación ─────────────────────────────────────────────────────────
import ClientVentas from '@/views/ventas/ClientVentas.vue'
import ClientGuiaRemision from '@/views/ventas/ClientGuiaRemision.vue'
import ClientNotaCredito from '@/views/ventas/ClientNotaCredito.vue'
import ClientDocumentosEmitidos from '@/views/ventas/ClientDocumentosEmitidos.vue'

// ── 3. Pedidos ──────────────────────────────────────────────────────────────
import ClientVentasPedidos from '@/views/ventas/ClientVentasPedidos.vue'
import ClientVentasPedidoNuevo from '@/views/ventas/ClientVentasPedidoNuevo.vue'
import ClientVentasPedidoVer from '@/views/ventas/ClientVentasPedidoVer.vue'

// ── 4. Proformas ────────────────────────────────────────────────────────────
import ClientVentasProformar from '@/views/ventas/ClientVentasProformar.vue'
import ProformaNueva from '@/views/ventas/ProformaNueva.vue'

// ── 5. Clientes ────────────────────────────────────────────────────────────
import ClientClientesListado from '@/views/clientes/ClientClientesListado.vue'
import ClientClientesNuevo from '@/views/clientes/ClientClientesNuevo.vue'
import ClientClientesEditar from '@/views/clientes/ClientClientesEditar.vue'
import ClientClientesVer from '@/views/clientes/ClientClientesVer.vue'
import ClientCargaMasivaClientes from '@/views/clientes/ClientCargaMasivaClientes.vue'
import ClientEstadoCuenta from '@/views/clientes/ClientEstadoCuenta.vue'

// ── 6. Productos (inventario) ──────────────────────────────────────────────
import ClientInventarioProductos from '@/views/inventario/ClientInventarioProductos.vue'
import ClientInventarioCategorias from '@/views/inventario/ClientInventarioCategorias.vue'
import ClientInventarioAlmacenes from '@/views/inventario/ClientInventarioAlmacenes.vue'
import ClientInventarioMarcas from '@/views/inventario/ClientInventarioMarcas.vue'
import ClientInventarioUnidadesMedida from '@/views/inventario/ClientInventarioUnidadesMedida.vue'
import ClientInventarioStock from '@/views/inventario/ClientInventarioStock.vue'
import ClientComprasCargaMasiva from '@/views/compras/ClientComprasCargaMasiva.vue'

// ── 7. Compras (incluye gestión de proveedores) ────────────────────────────
import ClientComprasOrdenes from '@/views/compras/ClientComprasOrdenes.vue'
import ClientComprasRegistrar from '@/views/compras/ClientComprasRegistrar.vue'
import ClientEstadoCuentaProveedor from '@/views/compras/ClientEstadoCuentaProveedor.vue'
import ClientProveedoresListado from '@/views/proveedores/ClientProveedoresListado.vue'
import ClientProveedoresNuevo from '@/views/proveedores/ClientProveedoresNuevo.vue'
import ClientCargaMasivaProveedores from '@/views/proveedores/ClientCargaMasivaProveedores.vue'

// ── 8. Caja (incluye bancos y movimientos) ─────────────────────────────────
import ClientCajas from '@/views/cajas/ClientCajas.vue'
import ClientCajasListado from '@/views/cajas/ClientCajasListado.vue'
import ClientCajasMovimientos from '@/views/cajas/ClientCajasMovimientos.vue'
import ClientCajasConfiguracion from '@/views/cajas/ClientCajasConfiguracion.vue'
import ClientBancosCuentas from '@/views/bancos/ClientBancosCuentas.vue'
import ClientBancosMovimientos from '@/views/bancos/ClientBancosMovimientos.vue'

// ── 9. Reportes ────────────────────────────────────────────────────────────
import ClientReportesVentas from '@/views/reportes/ClientReportesVentas.vue'
import ClientReportesUtilidadAproximada from '@/views/reportes/ClientReportesUtilidadAproximada.vue'
import ClientReportesProductosVendidos from '@/views/reportes/ClientReportesProductosVendidos.vue'
import ClientReportesClientesDeuda from '@/views/reportes/ClientReportesClientesDeuda.vue'
import ClientReportesProveedoresDeuda from '@/views/reportes/ClientReportesProveedoresDeuda.vue'
import ClientReportesAts from '@/views/reportes/ClientReportesAts.vue'
import ClientReporteComisiones from '@/views/reportes/ClientReporteComisiones.vue'

// ── 10. Configuración ──────────────────────────────────────────────────────
import ClientConfiguracionFacturacion from '@/views/configuracion/ClientConfiguracionFacturacion.vue'
import ClientConfiguracionSecuenciales from '@/views/configuracion/ClientConfiguracionSecuenciales.vue'
import ClientConfiguracionCorreos from '@/views/configuracion/ClientConfiguracionCorreos.vue'
import ClientConfiguracionPlantillas from '@/views/configuracion/ClientConfiguracionPlantillas.vue'
import ClientConfiguracionUsuarios from '@/views/configuracion/ClientConfiguracionUsuarios.vue'
import ClientConfiguracionImpresiones from '@/views/configuracion/ClientConfiguracionImpresiones.vue'
import ClientComisionesConfiguracion from '@/views/configuracion/ClientComisionesConfiguracion.vue'

// ── Contabilidad (sin número en menú sidebar — pendiente de definir posición) ─
import ClientContabilidadAsientos from '@/views/contabilidad/ClientContabilidadAsientos.vue'

import ClientConfiguracionPermisos from '@/views/configuracion/ClientConfiguracionPermisos.vue'

// Control de acceso (roles, permisos y usuarios)
import ClientControlAccesoRoles    from '@/views/control-acceso/ClientControlAccesoRoles.vue'
import ClientControlAccesoUsuarios from '@/views/control-acceso/ClientControlAccesoUsuarios.vue'

const applyModule = (moduleCode, routes) => routes.map(route => ({
  ...route,
  meta: {
    requiresAuth: true,
    moduleCode,
    ...(route.meta || {})
  }
}))

// Control de validación de suscripción (true para desactivar bloqueo, dejar en false en produccion)
const SKIP_SUBSCRIPTION_VALIDATION = false
// Control de validación de módulos — activo, verificado con empresa_modulo
const SKIP_MODULE_VALIDATION = false

const childrenRoutes = [
  // Gestion de pago (siempre accesible para subir comprobante)
  {
    path: 'gestion-pago',
    name: 'GestionPago',
    component: GestionPago,
    meta: { requiresAuth: true, allowVencida: true }
  },
  // ── Perfil (sin módulo requerido) ──────────────────────────────────────
  {
    path: 'perfil',
    name: 'ClientProfile',
    component: () => import('@/views/perfil/ClientProfile.vue')
  },
  {
    path: 'configuracion-usuario',
    name: 'ClientSettings',
    component: () => import('@/views/perfil/ClientSettings.vue')
  },

  // ── 1. Dashboard ──────────────────────────────────────────────────────
  ...applyModule('dashboard', [
    { path: '',                redirect: { name: 'ClientDashboard' } },
    { path: 'dashboard',       name: 'ClientDashboard', component: ClientDashboard },
    { path: 'indicadores',     component: () => import('@/views/system/Placeholder.vue') }, // PENDIENTE
    { path: 'notificaciones',  component: () => import('@/views/system/Placeholder.vue') }, // PENDIENTE
    { path: 'accesos-rapidos', component: () => import('@/views/system/Placeholder.vue') }  // PENDIENTE
  ]),

  // ── 2. Facturación ─────────────────────────────────────────────────────
  //    Nueva factura · Documentos emitidos · Notas de crédito · Guías de remisión
  ...applyModule('ventas', [
    { path: 'ventas/facturacion',                                            component: ClientVentas },
    { path: 'ventas/documentos-emitidos', name: 'ClientDocumentosEmitidos', component: ClientDocumentosEmitidos },
    { path: 'ventas/notas-credito',                                          component: ClientNotaCredito },
    { path: 'ventas/guias-remision',                                         component: ClientGuiaRemision },
    // PENDIENTE:
    { path: 'ventas/cotizaciones', component: () => import('@/views/system/Placeholder.vue') },
    { path: 'ventas/entregas',     component: () => import('@/views/system/Placeholder.vue') },
    { path: 'ventas/cobros',       component: () => import('@/views/system/Placeholder.vue') },
    { path: 'ventas/pos',          component: () => import('@/views/system/Placeholder.vue') }
  ]),

  // ── 3. Pedidos ────────────────────────────────────────────────────────
  ...applyModule('pedidos', [
    { path: 'ventas/pedidos',              name: 'ClientVentasPedidos',      component: ClientVentasPedidos },
    { path: 'ventas/pedidos/nuevo',        name: 'ClientVentasPedidoNuevo',  component: ClientVentasPedidoNuevo },
    { path: 'ventas/pedidos/:id/editar',   name: 'ClientVentasPedidoEditar', component: ClientVentasPedidoNuevo },
    { path: 'ventas/pedidos/:id',          name: 'ClientVentasPedidoVer',    component: ClientVentasPedidoVer }
  ]),

  // ── 4. Proformas ──────────────────────────────────────────────────────
  ...applyModule('proformas', [
    { path: 'proformas',            component: ClientVentasProformar },
    { path: 'proformas/nueva',      component: ProformaNueva },
    { path: 'proformas/editar/:id', component: ProformaNueva }
  ]),

  // ── 5. Clientes ────────────────────────────────────────────────────────
  //    Listado · Nuevo · Editar · Ver · Carga masiva · Estado de cuenta
  ...applyModule('clientes', [
    { path: 'clientes',               component: ClientClientesListado },
    { path: 'clientes/nuevo',         component: ClientClientesNuevo },
    { path: 'clientes/editar/:id',    component: ClientClientesEditar },
    { path: 'clientes/ver/:id',       component: ClientClientesVer },
    { path: 'clientes/carga-masiva',  component: ClientCargaMasivaClientes },
    { path: 'clientes/estado-cuenta', component: ClientEstadoCuenta }
  ]),

  // ── 6. Productos ──────────────────────────────────────────────────────
  //    Productos · Categorías · Marcas · Unidades · Almacenes · Stock · Carga masiva
  ...applyModule('inventario', [
    { path: 'inventario/productos',        component: ClientInventarioProductos },
    { path: 'inventario/productos/nuevo',  component: () => import('@/views/inventario/InventarioNuevoProducto.vue') },
    {
      path: 'inventario/editar/:id',
      component: () => import('@/views/inventario/InventarioEditarProducto.vue'),
      meta: { accessPath: '/inventario/productos' }
    },
    { path: 'inventario/categorias',       component: ClientInventarioCategorias },
    { path: 'inventario/marcas',           component: ClientInventarioMarcas },
    { path: 'inventario/unidades-medida',  component: ClientInventarioUnidadesMedida },
    { path: 'inventario/almacenes',        component: ClientInventarioAlmacenes },
    { path: 'inventario/stock',            component: ClientInventarioStock },
    { path: 'inventario/carga-masiva',     component: ClientComprasCargaMasiva },
    // PENDIENTE:
    { path: 'inventario/movimientos',    component: () => import('@/views/system/Placeholder.vue') },
    { path: 'inventario/transferencias', component: () => import('@/views/system/Placeholder.vue') },
    { path: 'inventario/ajustes',        component: () => import('@/views/system/Placeholder.vue') }
  ]),

  // ── 7. Compras ─────────────────────────────────────────────────────────
  //    Mis compras · Registrar · Proveedores · Carga masiva · Estado de cuenta
  ...applyModule('compras', [
    { path: 'compras/ordenes',                    component: ClientComprasOrdenes },
    { path: 'compras/ordenes/:id',                component: ClientComprasOrdenes },
    { path: 'compras/registrar',                  component: ClientComprasRegistrar },
    { path: 'compras/estado-cuenta',              component: ClientEstadoCuentaProveedor },
    { path: 'personas/proveedores',               component: ClientProveedoresListado },
    { path: 'personas/proveedores/nuevo',         component: ClientProveedoresNuevo },
    { path: 'proveedores/nuevo',                  component: ClientProveedoresNuevo },
    { path: 'personas/proveedores/carga-masiva',  component: ClientCargaMasivaProveedores },
    { path: 'personas/proveedores/editar/:id',    component: () => import('@/views/proveedores/ClientProveedoresEditar.vue') },
    { path: 'proveedores/editar/:id',             component: () => import('@/views/proveedores/ClientProveedoresEditar.vue') },
    { path: 'personas/proveedores/ver/:id',       component: () => import('@/views/proveedores/ClientProveedoresVer.vue') },
    { path: 'proveedores/ver/:id',                component: () => import('@/views/proveedores/ClientProveedoresVer.vue') },
    // PENDIENTE:
    { path: 'compras/solicitudes', component: () => import('@/views/system/Placeholder.vue') },
    { path: 'compras/recepcion',   component: () => import('@/views/system/Placeholder.vue') },
    { path: 'compras/pagos',       component: () => import('@/views/system/Placeholder.vue') },
    { path: 'compras/historial',   component: () => import('@/views/system/Placeholder.vue') }
  ]),

  // ── 8. Caja ────────────────────────────────────────────────────────────
  //    Control de caja · Historial sesiones · Configurar · Bancos
  ...applyModule('caja', [
    { path: 'cajas',                           name: 'ClientCajas',              component: ClientCajas },
    { path: 'cajas/historial',                 name: 'ClientCajasListado',       component: ClientCajasListado },
    { path: 'cajas/sesiones/:sesion_id',       name: 'ClientCajasMovimientos',   component: ClientCajasMovimientos },
    { path: 'cajas/configuracion',             name: 'ClientCajasConfiguracion', component: ClientCajasConfiguracion },
    { path: 'cajas/creditos',                  name: 'ClientCajasCreditos',      component: () => import('@/views/cajas/ClientCajasCreditos.vue') },
    { path: 'finanzas/bancos',                                                   component: ClientBancosCuentas },
    { path: 'finanzas/bancos/:id/movimientos', name: 'ClientBancosMovimientos',  component: ClientBancosMovimientos },
    // PENDIENTE:
    { path: 'finanzas/cuentas-cobrar',  component: () => import('@/views/finanzas/ClientCuentasCobrar.vue') },
    { path: 'finanzas/cuentas-pagar',   component: () => import('@/views/system/Placeholder.vue') },
    { path: 'finanzas/flujo-caja',      component: () => import('@/views/system/Placeholder.vue') },
    { path: 'finanzas/conciliaciones',  component: () => import('@/views/system/Placeholder.vue') },
    { path: 'finanzas/presupuestos',    component: () => import('@/views/system/Placeholder.vue') }
  ]),

  // ── 9. Reportes ────────────────────────────────────────────────────────
  ...applyModule('reportes', [
    { path: 'reportes/ventas',               component: ClientReportesVentas },
    { path: 'reportes/utilidad-aproximada',  component: ClientReportesUtilidadAproximada },
    { path: 'reportes/productos-vendidos',   component: ClientReportesProductosVendidos },
    { path: 'reportes/clientes-deuda',       component: ClientReportesClientesDeuda },
    { path: 'reportes/proveedores-deuda',    component: ClientReportesProveedoresDeuda },
    { path: 'reportes/ats',                  component: ClientReportesAts },
    { path: 'reportes/comisiones',           component: ClientReporteComisiones }
  ]),

  // ── 10. Configuración ──────────────────────────────────────────────────
  //    SRI · Secuenciales · Usuarios · Correos · Plantillas · Impresiones · Comisiones
  ...applyModule('configuracion', [
    { path: 'configuracion/sri',          component: ClientConfiguracionFacturacion },
    { path: 'configuracion/secuenciales', component: ClientConfiguracionSecuenciales },
    { path: 'configuracion/usuarios',     component: ClientConfiguracionUsuarios },
    { path: 'configuracion/correos',      component: ClientConfiguracionCorreos },
    { path: 'configuracion/plantillas',   component: ClientConfiguracionPlantillas },
    { path: 'configuracion/impresiones',  component: ClientConfiguracionImpresiones },
    { path: 'configuracion/comisiones',   component: ClientComisionesConfiguracion },
    { path: 'configuracion/permisos',        component: ClientConfiguracionPermisos },
    { path: 'control-acceso/roles',     component: ClientControlAccesoRoles },
    { path: 'control-acceso/usuarios',  component: ClientControlAccesoUsuarios }
  ]),

  // ── Contabilidad (pendiente de posición en menú sidebar) ──────────────
  ...applyModule('contabilidad', [
    { path: 'contabilidad/asientos',           component: ClientContabilidadAsientos },
    // PENDIENTE:
    { path: 'contabilidad/plan-cuentas',       component: () => import('@/views/system/Placeholder.vue') },
    { path: 'contabilidad/mayor-general',      component: () => import('@/views/system/Placeholder.vue') },
    { path: 'contabilidad/balance-general',    component: () => import('@/views/system/Placeholder.vue') },
    { path: 'contabilidad/estado-resultados',  component: () => import('@/views/system/Placeholder.vue') },
    { path: 'contabilidad/cierre',             component: () => import('@/views/system/Placeholder.vue') }
  ]),

]

const routes = [
  {
    path: '/iniciar-sesion',
    name: 'InicioSesion',
    component: InicioSesion,
    meta: { requiresAuth: false }
  },
  {
    path: '/recuperar-clave',
    name: 'RecuperarClave',
    component: RecuperarClave,
    meta: { requiresAuth: false }
  },
  {
    path: '/clientes/recuperar-clave',
    name: 'ClienteRecuperarClaveToken',
    component: ClientCambioClaveToken,
    meta: { requiresAuth: false }
  },
  {
    path: '/clientes/cambiar-clave',
    name: 'ClienteCambiarClaveToken',
    component: ClientCambioClaveToken,
    meta: { requiresAuth: false }
  },
  {
    path: '/upgrade',
    name: 'ModuleRestricted',
    component: ModuleRestricted,
    meta: { requiresAuth: false }
  },
  {
    path: '/login',
    redirect: '/iniciar-sesion'
  },
  {
    path: '/cerrar-sesion',
    name: 'CerrarSesion',
    meta: { requiresAuth: false },
    beforeEnter(to, from, next) {
      // Limpiar todos los tokens de sesión del cliente
      const claves = [
        'token_acceso_cliente', 'token_refresco_cliente',
        'client_access_token', 'client_refresh_token',
        'usuario_cliente', 'empresa_cliente', 'modulos_cliente'
      ]
      claves.forEach(clave => localStorage.removeItem(clave))
      next({ path: '/iniciar-sesion', replace: true })
    },
    component: { render: () => null }
  },
  {
    path: '/',
    component: ClientLayout,
    meta: { requiresAuth: true },
    children: childrenRoutes
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

const requiresAuth = (route) => route.meta?.requiresAuth !== false

router.beforeEach((to, from, next) => {
  // ── Limpiar hash de handoff de tokens ─────────────────────────────────────
  // createWebHistory captura window.location al importar el módulo, ANTES de
  // que main.js pueda limpiar el hash con history.replaceState. El router
  // hace la primera navegación con el hash incluido (#t=TOKEN&r=REFRESH).
  // Interceptamos esa navegación y redirigimos a la ruta sin hash.
  if (from === START_LOCATION && to.hash && /^#t=/.test(to.hash)) {
    return next({ path: to.path, query: to.query, hash: '', replace: true })
  }
  // ──────────────────────────────────────────────────────────────────────────

  // Evitar navegación duplicada que puede provocar loops — pero NO en la
  // navegación inicial (from === START_LOCATION), donde from.path es '/' igual
  // que to.path cuando la URL está en '/', lo que bloquearía el redirect a /dashboard.
  if (from !== START_LOCATION && to.path === from.path && JSON.stringify(to.query || {}) === JSON.stringify(from.query || {})) {
    return next(false)
  }

  // Si estamos en un subdominio de empresa ({ruc}.sicecom.com) y la ruta es
  // pública (login, recuperar clave, etc.), redirigir a app.sicecom.com.
  // Las rutas de activación de cuenta (cambiar-clave) pueden funcionar en ambos subdominios.
  const rutasPublicasExcluidas = ['ClientCambioClaveToken', 'ClienteRecuperarClaveToken', 'ClienteCambiarClaveToken']
  if (!esSubdominioLogin() && !rutasPublicasExcluidas.includes(to.name)) {
    if (!auth.estaAutenticado()) {
      // Usar siempre construirUrlLogout (incluye ?accion=cerrar-sesion) para que
      // app.sicecom.com limpie su propio localStorage antes de mostrar el login.
      // Esto también soluciona la carrera entre cerrarSesion() y router.push.
      const urlLogout = construirUrlLogout()
      if (urlLogout) {
        window.location.replace(urlLogout)
        return
      }
    }
  }

  const needsAuth = to.matched.some(requiresAuth)
  const isLoggedIn = auth.estaAutenticado()

  if (needsAuth && !isLoggedIn) {
    return next({ path: '/iniciar-sesion', query: { redireccion: to.fullPath } })
  }

  if (to.name === 'InicioSesion' && isLoggedIn) {
    // Si el usuario ya está autenticado y visita app.sicecom.com,
    // redirigirlo automáticamente al subdominio de su empresa ({ruc}.sicecom.com).
    // En localhost construirUrlEmpresa devuelve null y se hace push interno.
    if (esSubdominioLogin() && !store.state.user?.is_super_admin) {
      const ruc         = store.state.user?.company?.ruc
      const tokenAcceso = localStorage.getItem('token_acceso_cliente')
      const tokenRefr   = localStorage.getItem('token_refresco_cliente')
      if (ruc && tokenAcceso) {
        const url = construirUrlEmpresa(ruc, tokenAcceso, tokenRefr, '/')
        if (url) {
          window.location.replace(url)
          return
        }
      }
    }
    return next('/')
  }

  if (!needsAuth) {
    return next()
  }

  // Validar que el usuario autenticado esté en el subdominio correcto para su empresa.
  // Si el RUC del subdominio no coincide con el RUC de su empresa, redirigirlo.
  if (!esSubdominioLogin()) {
    const rucSubdominio = obtenerRucDesdeSubdominio()
    const rucUsuario    = store.state.user?.company?.ruc
    if (rucSubdominio && rucUsuario && rucSubdominio !== rucUsuario) {
      const tokenAcceso = localStorage.getItem('token_acceso_cliente')
      const tokenRefr   = localStorage.getItem('token_refresco_cliente')
      const url = construirUrlEmpresa(rucUsuario, tokenAcceso, tokenRefr, to.fullPath)
      if (url) {
        window.location.replace(url)
        return
      }
    }
  }

  // Permitir rutas especiales sin volver a redirigirlas
  if (to.name === 'ModuleRestricted' || to.name === 'GestionPago') {
    return next()
  }

  // Verificar suscripcion para usuarios no super admin
  const currentUser = store.getters.currentUser
  if (currentUser && !currentUser.is_super_admin) {
    if (!SKIP_SUBSCRIPTION_VALIDATION) {
      const estado = store.getters.subscriptionEstado
      // Vencida o cancelada: solo /gestion-pago accesible
      if (estado === 'vencida' || estado === 'cancelada') {
        return next({ name: 'GestionPago' })
      }
    }
  }

  if (!SKIP_MODULE_VALIDATION) {
    // Filtrado por ruta del nuevo sistema de control de acceso.
    // Compara to.path contra submodulos permitidos (rutas reales del frontend).
    const SIEMPRE_PERMITIDAS = ['/', '/dashboard', '/perfil', '/upgrade', '/gestion-pago', '/cerrar-sesion', '/iniciar-sesion']
    const rutasPermitidas = (store.getters.activeModules || []).map(String)

    // Si el store aun no tiene rutas cargadas, permitir navegacion para no
    // romper UX durante la carga inicial.
    const rutaValidacion = to.meta?.accessPath || to.path

    if (rutasPermitidas.length > 0 && !SIEMPRE_PERMITIDAS.includes(to.path)) {
      const permitida = rutasPermitidas.some(ruta =>
        rutaValidacion === ruta || rutaValidacion.startsWith(ruta + '/')
      )
      if (!permitida) {
        return next({
          name: 'ModuleRestricted',
          query: { module: rutaValidacion, redirect: to.fullPath }
        })
      }
    }
  }

  return next()
})

export default router


